export default __webpack_public_path__ + "static/dismoi-screenshot-selon-que-choisir-mounted-website-desktop-6ed85f2cad0c6fd00f272e36e04223fd.jpg";